import { LOADING_STATUS, SUBMISSION_STATUS } from '../../config';
/* eslint-disable import/prefer-default-export */
export function sequenceIdsSelector(state) {
  if (state.courseware.courseStatus !== 'loaded') {
    return [];
  }
  const { sectionIds = [] } = state.models.coursewareMeta[state.courseware.courseId];

  const sequenceIds = sectionIds
    .flatMap(sectionId => state.models.sections[sectionId].sequenceIds);

  return sequenceIds;
}

export function electivesStatusSelector(state) {
  const electivesFetchStatus= state.courseware.electivesStatus
  const electivesUpdateStatus= state.courseware.updateElectivesStatus

  return {
    isElectivesLoading: electivesFetchStatus === LOADING_STATUS.LOADING,
    isElectivesUpdating: electivesUpdateStatus === SUBMISSION_STATUS.SUBMITTING,
  }
}

export function selectElectiveAfterSubmitModalOpen(state) {
  return state.courseware.electiveAfterSubmitModalOpen;
}

export function selectTotalSelectedElectives(state) {
  return state.courseware.totalSelectedElectives;
}
